<div [ngClass]="{ mobile: isOnMobile, desktop: !isOnMobile }">
  <div class="hero-wrapper">
    @if (uiState() === SmartFixUIState.Idle && !staticHeroOnly()) {
      <video #introVideo alt="Smart fix animation" class="hero-element intro-video"></video>
      <video
        #transitionVideo
        alt="Smart fix transition"
        class="hero-element transition-video"
        (ended)="onVideoEnded()"
      ></video>
    }
    <img
      [src]="
        uiState() === SmartFixUIState.Feedback
          ? '/assets/images/smart-fix-assets/smart-fix-static-feedback.svg'
          : '/assets/images/smart-fix-assets/smart-fix-static-desktop.svg'
      "
      alt="Smart fix static"
      [class]="
        'hero-element static' +
        (staticHeroOnly() || uiState() === SmartFixUIState.Chat || uiState() === SmartFixUIState.Feedback
          ? ' show'
          : '')
      "
    />
  </div>
</div>
